export default function isExternalLink(link: string) {
  // eslint-disable-next-line no-useless-escape
  return /^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/.test(
    link
  );
}
